import { c as _c } from "react/compiler-runtime";
import { useFeatures } from '@udemy-v2/react-experimentation';
import { DateIntervalType } from '@udemy-v2/subscription-graphql';
const BYPASS_GWG_PLAN_COMPARISON = 'bypass_gwg_plan_comparison_page_and_go_to_checkout';

/**
 * Reads the bypass_gwg_plan_comparison_page_and_go_to_checkout experiment variant
 * and returns a DateIntervalType preference for direct checkout, or undefined for control.
 */
export function useGwgPlanPreference() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [BYPASS_GWG_PLAN_COMPARISON];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments: features
  } = useFeatures(t0);
  const variant = features.get(BYPASS_GWG_PLAN_COMPARISON)?.configuration?.bypassPlanComparisonWith as 'control' | 'monthly' | 'annual' | undefined;
  if (variant === "monthly") {
    return DateIntervalType.Month;
  }
  if (variant === "annual") {
    return DateIntervalType.Year;
  }
}